import { createContext, useContext } from 'react'

export type DocumentPaneTab = 'pdf' | 'text'

/** Something to show in the document pane; `id` changes on every request so a repeat re-runs. */
export type DocumentPaneTarget =
  | { kind: 'quote'; text: string; isSearch: boolean; id: number }
  | { kind: 'page'; page: number; id: number }

export type DocumentPaneState = {
  tab: DocumentPaneTab
  setTab: (tab: DocumentPaneTab) => void
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
  target: DocumentPaneTarget | null
  /** Finds a quote (or, with `isSearch`, a search the agent ran) in the document text. */
  showQuote: (text: string, options?: { isSearch?: boolean }) => void
  /** Scrolls the current view to a page. */
  showPage: (page: number) => void
}

export const DocumentPaneContext = createContext<DocumentPaneState | null>(null)

export function useDocumentPane(): DocumentPaneState {
  const state = useContext(DocumentPaneContext)
  if (!state) throw new Error('useDocumentPane must be used inside DocumentPaneProvider')
  return state
}
